import { Controller } from "@hotwired/stimulus";
import baguetteBox from "baguettebox.js/dist/baguetteBox.js";

export default class extends Controller {
  static values = { refreshPath: String };
  connect() {
    baguetteBox.run(".gallery");
  }
  handleError() {
    if (!this.hasRefreshPathValue) return;

    fetch(this.refreshPathValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('[name="csrf-token"]').content,
      },
    })
      .then((response) => response.text())
      .then((html) => Turbo.renderStreamMessage(html));
  }
}
